import React from 'react';
import {MenuOutlined} from '@ant-design/icons';
import {Button, Popover} from 'antd';

interface ViewProps {
    options: React.ReactNode[];
    title?: string;
    forceOpen?: boolean;
}

export const PopoverWithOptions: React.FunctionComponent<ViewProps> = (props) => {
    const { title, options, forceOpen } = props;
    const [open, setOpen] = React.useState<boolean>(false);

    const handleOpenChange = React.useCallback( (newOpen: boolean) => {
        if (forceOpen !== undefined) return;
        setOpen(newOpen);
    }, [forceOpen]);

    React.useEffect( ()=>{
        if ( forceOpen !== undefined ){
            setOpen(forceOpen);
        }else{
            setOpen(false);
        }
    }, [forceOpen] );

    return (
        <Popover
            content={options}
            title={title}
            trigger="click"
            open={open}
            onOpenChange={handleOpenChange}
        >
            <Button type="link" size="small" icon={<MenuOutlined />} />
        </Popover>
    );

};
